import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import AxiosDataWrapper
  from '@avtechsoftware/react-component-library/src/components/common/AxiosDataWrapper/AxiosDataWrapper';
import AxiosDataIsLoaded
  from '@avtechsoftware/react-component-library/src/components/common/AxiosDataWrapper/AxiosDataIsLoaded/AxiosDataIsLoaded';
import { getNextNumericalName } from '@avtechsoftware/ra-javascript-utilities/src/utilities/validation/ObjectListUtils';
import {
  selectNotificationGroupList,
  selectNotificationGroupsCrudOperation,
  selectNotificationGroupsCrudStatus,
} from '../../../../redux/slices/notificationGroupsSlice/notificationGroupsSlice';
import GenericErrorFallback from '../../../common/GenericErrorFallback/GenericErrorFallback';
import NotificationGroupForm from './NotificationGroupForm';
import TransportType from '../../../../utility/types/TransportType';
import { CrudType } from '../../../../utility/types/CrudType';
import { CrudStatus } from '../../../../utility/types/CrudStatus';
import NotificationGroupUtility from '../../../../utility/NotificationGroupUtility';

function NotificationGroupFormWrapper(props) {
  const { notificationGroupId, clone } = props;
  const notificationGroupList = useSelector(selectNotificationGroupList);
  const crudOperation = useSelector(selectNotificationGroupsCrudOperation);
  const crudStatus = useSelector(selectNotificationGroupsCrudStatus);

  if (crudOperation === CrudType.READ && crudStatus !== CrudStatus.SUCCESS) {
    return (
      <div className="row d-flex justify-content-center my-5">
        <div>
          <ProgressSpinner />
        </div>
      </div>
    );
  }
  const stringifyContext = (recipient) => {
    switch (recipient.transportId) {
      case TransportType.EMAIL:
        return recipient.userId ? '' : NotificationGroupUtility.safeParse(recipient.context).emailAddress;
      // case TransportType.EMAIL_SMS:
      //   return recipient.context;
      case TransportType.WEBHOOK:
        return JSON.parse(recipient.context).url;
      default:
        return '';
    }
  };

  if (!notificationGroupId) {
    return (
      <AxiosDataWrapper url="/subscription/fetch-scrubbed-user-list" config={{ dataTitle: 'users' }}>
        <AxiosDataIsLoaded>
          <NotificationGroupForm
            initNotificationGroup={{
              name: getNextNumericalName(notificationGroupList, 'New Notification Group', 'name'),
              recipients: [{
                id: 0,
                transportId: '0',
                context: '',
                userId: 0,
              }],
            }}
          />
        </AxiosDataIsLoaded>
      </AxiosDataWrapper>
    );
  }

  const oldNotificationGroup = notificationGroupList.find((ng) => ng.id === notificationGroupId);
  let newNotificationGroup = null;
  if (oldNotificationGroup) {
    const newRecipients = oldNotificationGroup.recipients.map(({ createdAt, ...recipient }) => (
      {
        ...recipient,
        context: stringifyContext(recipient),
        userId: recipient.userId ? recipient.userId.toString() : null,
        transportId: recipient.transportId.toString(),
      }
    ));
    newNotificationGroup = { ...oldNotificationGroup, recipients: newRecipients };
    delete newNotificationGroup.subscriptionId;
    delete newNotificationGroup.isSuspended;
    delete newNotificationGroup.uniqueAlertCount;
    delete newNotificationGroup.createdAt;
  }

  if (!newNotificationGroup) {
    return (
      <div className="row d-flex justify-content-center my-5">
        <div>
          <GenericErrorFallback
            resetErrorBoundary={() => window.location.reload()}
            error={{ message: 'Unexpected error loading notification group.' }}
          />
        </div>
      </div>
    );
  }

  if (clone) {
    delete newNotificationGroup.id;
    newNotificationGroup.recipients.forEach((recipient) => {
      delete recipient.id;
    });
    newNotificationGroup = {
      ...newNotificationGroup,
      name: `${newNotificationGroup.name} Clone`,
    };
  }

  return (
    <AxiosDataWrapper url="/subscription/fetch-scrubbed-user-list" config={{ dataTitle: 'users' }}>
      <AxiosDataIsLoaded>
        <NotificationGroupForm
          initNotificationGroup={newNotificationGroup}
        />
      </AxiosDataIsLoaded>
    </AxiosDataWrapper>
  );
}

NotificationGroupFormWrapper.defaultProps = {
  notificationGroupId: null,
  clone: false,
};

NotificationGroupFormWrapper.propTypes = {
  notificationGroupId: PropTypes.number,
  clone: PropTypes.bool,
};

export default NotificationGroupFormWrapper;
